var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-book-open-page-variant",
      show: _vm.dialog,
      maxWidth: "40%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-teacher", {
                          attrs: {
                            model: _vm.model.teacher_id,
                            error:
                              _vm.errors.teacher_id && _vm.errors.length > 0,
                            data: _vm.model.teacher,
                            errors: _vm.errors.teacher_id,
                            label: "Professor*",
                            autoComplete: "",
                            autofocus: "",
                            clearable: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "teacher_id", $event)
                            },
                            "update:data": function ($event) {
                              return _vm.$set(_vm.model, "teacher", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-company", {
                          attrs: {
                            model: _vm.model.companies,
                            label: "Empresa (Opcional)",
                            multiple: "",
                            dense: "",
                            "select-all": "",
                            "filter-time-sheet": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "companies", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("sys-select-campus", {
                          attrs: {
                            model: _vm.model.campuses,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.campuses,
                            label: "Campus*",
                            "only-active": "",
                            multiple: "",
                            "select-all": "",
                            "filter-relation": "groups",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "campuses", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-shift", {
                          attrs: {
                            model: _vm.model.shifts,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.shifts,
                            multiple: "",
                            label: "Turno*",
                            "select-all": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "shifts", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-occurrence-sheet-type", {
                          attrs: {
                            model: _vm.model.types,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.types,
                            label: "Tipo*",
                            dense: "",
                            multiple: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "types", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            error: _vm.errors.length > 0,
                            "error-messages": _vm.errors.year,
                            label: "Ano*",
                            disabled: "",
                            dense: "",
                          },
                          model: {
                            value: _vm.model.year,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "year", $$v)
                            },
                            expression: "model.year",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-month", {
                          attrs: {
                            model: _vm.model.month,
                            dense: "",
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.month,
                            label: "Mês*",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "month", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Consolidar todos os campus na folha de ponto",
                            label: "Consolidar Campus",
                            inset: "",
                          },
                          model: {
                            value: _vm.model.consolidate_campuses,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "consolidate_campuses", $$v)
                            },
                            expression: "model.consolidate_campuses",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Consolidar todos os turnos na folha de ponto",
                            label: "Consolidar Turno",
                            inset: "",
                          },
                          model: {
                            value: _vm.model.consolidate_shifts,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "consolidate_shifts", $$v)
                            },
                            expression: "model.consolidate_shifts",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper": "Incluir intervalos",
                            label: "Intervalo",
                            inset: "",
                          },
                          model: {
                            value: _vm.model.include_ranges,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "include_ranges", $$v)
                            },
                            expression: "model.include_ranges",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper": "Consolidar horários por data",
                            label: "Consolidar Datas",
                            inset: "",
                          },
                          model: {
                            value: _vm.model.consolidade_dates,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "consolidade_dates", $$v)
                            },
                            expression: "model.consolidade_dates",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Exibir feriados no ponto do professor",
                            label: "Exibir Feriado",
                            inset: "",
                          },
                          model: {
                            value: _vm.model.show_holidays,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "show_holidays", $$v)
                            },
                            expression: "model.show_holidays",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-row"),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }